import { forwardRef } from "react";
import Flex from "../flex";
import Box from "../box";
import Text from "../text";
import { InfoCircleFilled, CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const iconMap = {
  info: InfoCircleFilled,
  success: CheckCircleFilled,
  error: CloseCircleFilled,
  warning: ExclamationCircleFilled
};
const colorMap = {
  info: "info.base",
  success: "positive.base",
  error: "negative.base",
  warning: "warning.base"
};
export const Result = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    status = "info",
    icon,
    title,
    description,
    children,
    ...rest
  } = _ref;
  const color = colorMap[status] ?? colorMap.info;
  const Icon = iconMap[status] ?? iconMap.info;
  return /*#__PURE__*/_jsxs(Flex, {
    ref: ref,
    ...rest,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(Text, {
      mb: 2,
      fontSize: 7,
      color: color,
      children: icon ?? /*#__PURE__*/_jsx(Icon, {})
    }), title && /*#__PURE__*/_jsx(Text, {
      fontSize: 3,
      children: title
    }), description && /*#__PURE__*/_jsx(Text, {
      fontSize: 1,
      color: "gray.base",
      children: description
    }), children && /*#__PURE__*/_jsx(Box, {
      mt: 3,
      children: children
    })]
  });
});
export default Result;